import {ArrayHelper} from './array';
import {DocumentsHelper} from './document';
import {FieldsHelper} from './fields';
import {QueryHelper} from './query';
import {UtilsHelper} from './utils';

export const Conditions = {
  array: ArrayHelper,
  fields: FieldsHelper,
  query: QueryHelper,
  utils: UtilsHelper,
  documents: DocumentsHelper,
};
